import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Webhook Webhook v2 Configuration Validator
 * Validates webhook configuration including URL, secret, and payload
 */
export const Webhook_Webhook_2_ConfigValidator = z.object({
    url: requiredString('Webhook URL is required'),
    requestMethod: z.enum(['GET', 'POST', 'PUT', 'DELETE', 'PATCH']).default('POST'),
    headers: z.record(z.string(), z.string()).optional(),
    payload: z.record(z.string(), z.any()).optional(),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true; // Allow undefined, null, or empty string
        try {
            JSON.parse(val); // Try to parse as JSON
            return true;
        }
        catch {
            return false; // Invalid JSON
        }
    }, {
        error: 'Must be empty string or valid JSON'
    })
});
//# sourceMappingURL=webhook-webhook-2.js.map